import EmailItem from "./EmailItem";
import EmailDraftItem from "./EmailDraftItem";
import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";

export default class EmailConversation {
    constructor(id, firstEmailItem, isKeyDecision = false, isUnlockingKeyDecision = false) {
        this.id = id;
        this.items = [firstEmailItem];

        // Player should only be able to make key decisions through the key decision menu
        this._isKeyDecision = isKeyDecision;
        // Player should now it it unlocks a key decision
        this._isUnlockingKeyDecision = isUnlockingKeyDecision;
    }

    getItems() {
        return this.items;
    }

    addItem(item, isKeyDecision = false, isUnlockingKeyDecision = false) {
        this.items.add(item);

        this._isKeyDecision = isKeyDecision;
        this._isUnlockingKeyDecision = isUnlockingKeyDecision;
    }

    markRead(value) {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].isRead = value;
        }
    }

    hasUnreadItems() {
        var unreadItems = this.items.filter(i => !i.isRead);
        return unreadItems.length > 0;
    }

    requiresReply() {
        return this.items.some(i => i instanceof EmailDraftItem && !i.isSent);
    }

    isInbox() {
        return this.getItems().some(i => i instanceof EmailItem && !(i instanceof EmailDraftItem));
    }

    isOutbox() {
        return this.getItems().some(i => i instanceof EmailDraftItem && i.isSent);
    }

    get isKeyDecision() {
        return this._isKeyDecision;
    }

    get isUnlockingKeyDecision() {
        return this._isUnlockingKeyDecision;
    }
    
    toObject() {
        return {
            id: this.id,
            items: this.items.map(i => i.toObject()),
        };
    }

    fromObject(obj, languagePack) {
        this.id = obj.id;

        this.items = []; // Clear any items added by constructor. The constructor shouldn't actually add any items...

        for (let i = 0; i < obj.items.length; i++) {
            const itemObj = obj.items[i];

            let serializedItem;
            if (itemObj.content.type === ContentTypes.TYPE_EMAIL) {
                serializedItem = new EmailItem().fromObject(itemObj, languagePack);
            } else if (itemObj.content.type === ContentTypes.TYPE_EMAIL_DRAFT) {
                serializedItem = new EmailDraftItem().fromObject(itemObj, languagePack);
            }

            this.items.push(serializedItem);
        }

        return this;
    }
}